import { useState, useEffect, useContext } from "react";
import { useForm } from "react-hook-form";
import { notifySuccess, notifyError } from "utils/toast";
import TollServices from "services/TollServices";
import { SidebarContext } from "context/SidebarContext";
import { Toll } from "@material-ui/icons";

const useTollSubmit = (
  id,
  selectedState,
  setSelectedState,
  selectedCity,
  setSelectedCity
) => {
  const [loading, setLoading] = useState(false);
  // const [selectedState, setSelectedState] = useState(null);
  // const [selectedCity, setSelectedCity] = useState(null);
  const [status, setStatus] = useState(true);
  const { isDrawerOpen, closeDrawer, setIsUpdate } = useContext(SidebarContext);

  const {
    register,
    handleSubmit,
    trigger,
    reset,
    formState: { errors },
    setValue,
  } = useForm();

  // fetch existing toll details when editing
  useEffect(() => {
    if (id) {
      setLoading(true);
      TollServices.getTollById(id)
        .then((res) => {
          const toll = Array.isArray(res.data) ? res.data[0] : res.data;
          if (!toll) return notifyError("No toll data found");
          setValue("toll_name", toll.toll_name);
          setValue("state", toll.state);
          setValue("city", toll.city);
          setValue("sedan_tag_price", toll.sedan?.tag_price || "");
          setValue("sedan_cash_price", toll.sedan?.cash_price || "");

          setValue("suv_tag_price", toll.suv?.tag_price || "");
          setValue("suv_cash_price", toll.suv?.cash_price || "");

          setValue("tempo_tag_price", toll.tempo_traveller?.tag_price || "");
          setValue("tempo_cash_price", toll.tempo_traveller?.cash_price || "");
          setValue("latitude", toll.latitude);
          setValue("longitude", toll.longitude);
          setValue("remark",toll.remark || "" )
          setSelectedState({
            label: toll.state_name || toll.state?.name,
            value: toll.id_state,
          });

          setSelectedCity({
            label: toll.city_name || toll.city?.name,
            value: toll.id_city,
          });

          setStatus(
            toll.status === true || toll.status === "Active" ? true : false
          );
        })
        .catch(() => notifyError("Failed to fetch toll details"))
        .finally(() => setLoading(false));
    } else {
      setStatus(true);
    }
  }, [id, setValue, reset]);

  useEffect(() => {
    if (!isDrawerOpen) {
      reset();
      setSelectedState(null);
      setSelectedCity(null);
      setStatus(true);
    }
  }, [isDrawerOpen, reset]);

const onSubmit = async (formData) => {
  setLoading(true);
  try {
    // if (!selectedState?.id || !selectedCity?.id) {
    //   notifyError("Please select State and City");
    //   return;
    // }



     if (
        !selectedState ||
        !selectedCity ||
        typeof selectedState.value !== "number" ||
        typeof selectedCity.value !== "number"
      ) {
        notifyError("Please select valid State and City");
        return;
      }


      const payload = {
        toll_name: formData.toll_name,

        id_state: selectedState.value,
        id_city: selectedCity.value,

  
      // id_state: selectedState.id,
      // id_city: selectedCity.id,

       id_state: selectedState.value,
        id_city: selectedCity.value,

      latitude: formData.latitude,
      longitude: formData.longitude,

      sedan: {
        tag_price: Number(formData.sedan_tag_price),
        cash_price: Number(formData.sedan_cash_price),
      },
      suv: {
        tag_price: Number(formData.suv_tag_price),
        cash_price: Number(formData.suv_cash_price),
      },
      tempo_traveller: {
        tag_price: Number(formData.tempo_tag_price),
        cash_price: Number(formData.tempo_cash_price),
      },

      status,
      remark: formData.remark,
    };

    if (id) {
      await TollServices.updateToll(id, payload);
      notifySuccess("Toll updated successfully!");
    } else {
      await TollServices.createToll(payload);
      notifySuccess("Toll added successfully!");
    }

    reset();
    setSelectedState(null);
    setSelectedCity(null);
    setStatus(true);
    setIsUpdate(true);
    closeDrawer();

  } catch (err) {
    notifyError(err?.response?.data?.message || err?.message);
  } finally {
    setLoading(false);
  }
};

  return {
    trigger,
    register,
    handleSubmit,
    selectedState,
    setSelectedState,
    selectedCity,
    setSelectedCity,
    status,
    setStatus,
    onSubmit,
    loading,
    errors,
    setValue,
  };
};

export default useTollSubmit;
